var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'cell-wrap': true,
  'cell-first': _vm.isOnly || _vm.isFirst,
  'cell-last': _vm.isOnly || _vm.isLast,
}},[(_vm.name)?_c('div',{staticClass:"cell-name"},[_vm._v(_vm._s(_vm.name))]):_vm._e(),_c('div',{staticClass:"cell-content"},[_vm._t("default"),(_vm.isLink)?_c('div',{staticClass:"with_arrow"}):_vm._e()],2),(!_vm.isOnly && !_vm.isLast && _vm.isBorder)?_c('div',{class:{'cell-border': _vm.isBorder}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }